<script lang="ts">
export default { name: 'CommonCheckbox', inheritAttrs: false }
</script>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  modelValue: unknown
  value: unknown
  label: string
  id: string
  disabled: boolean
}
const props = withDefaults(defineProps<Props>(), {
  disabled: false,
})

interface Emits {
  (e: 'update:modelValue', value: Props['modelValue']): void
}
const emit = defineEmits<Emits>()

// TODO: modelValueが配列ではない場合の処理の実装がまだ (今は必要でないため後回し。Boolean単体、trueValueやfalseValueの設定時、など)]

/** チェックされているか否か */
const checked = computed(() => {
  if (Array.isArray(props.modelValue)) {
    // 配列の場合
    const set = new Set(props.modelValue)
    return set.has(props.value)
  } else {
    // TODO: 配列ではないときの実装はまだです。
    console.warn('配列ではないときの実装はまだです。')
    return false
  }
})

/** changeイベント発火時の処理 */
function onChange(e: Event) {
  const checked = (e.target as HTMLInputElement).checked
  if (Array.isArray(props.modelValue)) {
    // 配列の場合
    const set = new Set(props.modelValue)
    // チェックされたら値を追加、チェックを外されたら値を削除
    checked ? set.add(props.value) : set.delete(props.value)
    // イベントを発行
    emit('update:modelValue', [...set])
  } else {
    // TODO: 配列ではないときの実装はまだです。
    console.warn('配列ではないときの実装はまだです。')
  }
}
</script>

<template>
  <span v-bind="$attrs" class="w-full inline-block">
    <input type="checkbox" :id="id" :value="value" :checked="checked" :disabled="disabled" @change="onChange" />
    <label :for="id" :class="[disabled ? 'text-gray-400 before:border-gray-300' : 'before:border-gray-600']">{{
      label
    }}</label>
  </span>
</template>

<style scoped>
/* TODO:tailwindに置き換える */

/* 元々のチェックボックス（非表示） */
input[type='checkbox'] {
  opacity: 0;
  position: absolute;
}

/* チェックボックスの代わりを成すラベル */
input[type='checkbox'] + label {
  display: none;
  cursor: pointer;
  display: inline-block;
  position: relative;
  padding-left: 25px;
  width: 100%;
  text-shadow: 1px 1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, -1px -1px 0 #fff;
}

@media screen and (max-width: 640px) {
  input[type='checkbox'] + label {
    font-size: 15px;
  }
}

/* ラベルの左に表示させる正方形のボックス□ */
input[type='checkbox'] + label::before {
  content: '';
  position: absolute;
  display: block;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  left: 0;
  top: 50%;
  border: 1px solid;
  border-radius: 4px;
  background-color: #fff; /* 背景の色変更 お好きな色を */
  text-shadow: 1px 1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, -1px -1px 0 #fff;
}

/* チェックが入った時のレ点 */
input[type='checkbox']:checked + label::after {
  content: '';
  position: absolute;
  display: block;
  box-sizing: border-box;
  width: 18px;
  height: 9px;
  margin-top: -9px;
  top: 50%;
  left: 3px;
  transform: rotate(-45deg);
  border-bottom: 3px solid;
  border-left: 3px solid;
  border-color: #f45912; /* チェックの色変更 お好きな色を */
}

input[type='checkbox']:focus-visible + label {
  @apply ring;
}

input[type='checkbox']:disabled + label {
  @apply cursor-default;
}
</style>
